import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendBookmark, BackendMutationCreateBookmarkArgs } from 'src/types/backend';

import { FRAGMENT_BOOKMARK } from './schema';

const MUTATION = gql`
  mutation CreateUserBookmark(
    $type: BookmarkTypeEnum!
    $name: String
    $link: String!
    $metadata: JSON
  ) {
    createBookmark(type: $type, name: $name, link: $link, metadata: $metadata) {
      ...Bookmark
    }
  }
  ${FRAGMENT_BOOKMARK}
`;

type Variables = BackendMutationCreateBookmarkArgs;
type Result = BackendBookmark;

export const createUserBookmark = async ({ type, name, link, metadata }: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      type,
      name,
      link,
      metadata: metadata ? JSON.stringify(metadata) : null,
    },
  });
  return getSingleProp<Result>(result.data);
};
